import React from "react";

const inr = (n) => new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(n);

/**
 * Compact informational footer that sits INSIDE the existing Quote/Estimate box (thin divider →
 * four labelled values → insurance disclaimer). Not a card/table/section. Effective Rate is the
 * existing net pre-GST taxable Air12 service amount ÷ declared chargeable weight (guards zero/NaN).
 */
export function QuoteWeightRateFooter({ physical, volumetric, chargeable, billable, taxableSubtotal }) {
  const ch = Number(chargeable);
  const bill = Number(billable);
  const sub = Number(taxableSubtotal);
  const effRate =
    ch > 0 && Number.isFinite(sub) ? Math.round(sub / ch) : null;
  // Show the billable line only when the configured minimum lifts billable above the calculated
  // chargeable weight. `billable` is the authoritative dynamic billable_weight_kg from pricing data
  // (never recomputed / never hardcoded here).
  const showBillable = Number.isFinite(bill) && Number.isFinite(ch) && bill > ch;

  const Item = ({ label, value, tid, full }) => (
    <div className={`min-w-0${full ? " col-span-2" : ""}`} data-testid={tid}>
      <div className="text-[11px] text-[hsl(var(--muted))] leading-tight">{label}</div>
      <div className="text-sm font-medium">{value}</div>
    </div>
  );

  return (
    <div className="mt-3 pt-3 border-t border-[hsl(var(--border))]" data-testid="quote-weight-rate-footer">
      <div className="grid grid-cols-2 gap-x-4 gap-y-2">
        <Item label="Physical Weight" value={`${physical} kg`} tid="qf-physical-weight" />
        <Item label="Volumetric Weight" value={`${volumetric} kg`} tid="qf-volumetric-weight" />
        <Item label="Declared Chargeable Weight" value={`${chargeable} kg`} tid="qf-declared-chargeable-weight" full={!showBillable} />
        {showBillable && (
          <Item label="Billable Weight" value={`${billable} kg`} tid="qf-billable-weight" />
        )}
        <Item label="Effective Rate" value={effRate != null ? `₹${inr(effRate)}/kg + GST` : "—"} tid="qf-effective-rate" full />
      </div>
      <p className="mt-2 text-[11px] text-[hsl(var(--muted))]" data-testid="qf-insurance-disclaimer">
        Insurance is mandatory and shall be charged basis declared invoice value.
      </p>
    </div>
  );
}
